/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

export const HorizontalLine = ({ lineColor, thin, width }) => {
  const style = css`
    background-color: ${lineColor || COLORS.blue};
    height: ${width || (thin ? '0.05rem' : '0.3rem')};
    border-radius: 1rem;
    justify-content: stretch;
  `

  return <div className="line" css={style} />
}

export const VerticalLine = ({ lineColor, thin, width, fullHeight }) => {
  const style = css`
    ${fullHeight ? 'height: 100%;' : ''}
    background-color: ${lineColor || COLORS.blue};
    width: ${width || (thin ? '0.05rem' : '0.3rem')};
    border-radius: 1rem;
    align-self: stretch;
  `

  return <div css={style} />
}
